import * as React from "react";
import { useDownload } from "../../helpers/hooks/useDownload";
import { API } from "../../services/base/BaseApi";

interface DownloadLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  path: string;
  fallbackFileName?: string;
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  path,
  fallbackFileName,
  children,
  className,
  onClick,
  ...rest
}) => {
  const { downloadFile, isDownloading } = useDownload();
  const href = `${API.defaults.baseURL}${path.replace(/^\//, ``)}`;

  const handleClick = React.useCallback(async (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) {
      return;
    }
    event.preventDefault();
    await downloadFile(path, fallbackFileName);
  }, [downloadFile, fallbackFileName, onClick, path]);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={className}
      aria-busy={isDownloading}
      aria-disabled={isDownloading}
      style={isDownloading ? { pointerEvents: `none`, opacity: 0.6 } : undefined}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </a>
  );
};
